module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Clothes/Crown-4fe64726c2bb1dc249da0258545785c778a5325b4e18e482c829c704c4146019.svg";